export const SYSTEM_OWNER_ID = "System";
export const CALCULATION_ERROR_ID = "calculation";
export var RequestPropertyName;
(function (RequestPropertyName) {
    RequestPropertyName["Request"] = "Request";
    RequestPropertyName["NAME"] = "Request.Name";
    RequestPropertyName["RATIO"] = "Request.Ratio";
    RequestPropertyName["CONTRIBUTION"] = "Request.Contribution";
    RequestPropertyName["VALUE"] = "Request.RateProperties.Value";
    RequestPropertyName["FROM"] = "Request.RateProperties.From";
    RequestPropertyName["TO"] = "Request.RateProperties.To";
    RequestPropertyName["MEAN"] = "Request.RateProperties.Mean";
    RequestPropertyName["SD"] = "Request.RateProperties.SD";
})(RequestPropertyName || (RequestPropertyName = {}));
export var RequestTemplate;
(function (RequestTemplate) {
    RequestTemplate["IMPORT_UPLOAD"] = "/workspaces/import/upload";
    RequestTemplate["IMPORT_FILE"] = "import/{fileId}";
    RequestTemplate["IMPORT_FILE_PARSE"] = "import/{fileId}/parse";
    // Workspace
    RequestTemplate["WORKSPACE_POST"] = ".";
    RequestTemplate["WORKSPACE_PUT"] = "{id}";
    RequestTemplate["DEPENDENT_WORKSPACES_PUT"] = "{id}/workspaces";
    // Cell model
    RequestTemplate["CELL_MODEL_POST"] = ".";
    RequestTemplate["CELL_MODEL_PUT"] = "{id}";
    RequestTemplate["POPULATION_POST"] = "{id}/populations";
    RequestTemplate["POPULATION_PUT_DELETE"] = "{id}/populations/{populationId}";
    RequestTemplate["VARIABLE_DELETE"] = "{id}/variables/{variableId}";
    RequestTemplate["DYNAMIC_POST"] = "{id}/populations/{populationId}/dynamics";
    RequestTemplate["DYNAMIC_PUT_DELETE"] = "{id}/populations/{populationId}/dynamics/{dynamicId}";
    RequestTemplate["POPULATION_EFFECTS_POST"] = "{id}/populations/{populationId}/population-effects";
    RequestTemplate["POPULATION_EFFECTS_PUT"] = "{id}/populations/{populationId}/population-effects";
    RequestTemplate["POPULATION_EFFECTS_DELETE"] = "{id}/populations/{populationId}/population-effects/{effectsId}";
    RequestTemplate["VARIABLE_EFFECTS_POST"] = "{id}/dynamic/{dynamicId}/variable-effects";
    RequestTemplate["VARIABLE_EFFECTS_PUT"] = "{id}/dynamic/{dynamicId}/variable-effects";
    RequestTemplate["VARIABLE_EFFECTS_DELETE"] = "{id}/dynamic/{variableId}/variable-effects/{effectId}";
    RequestTemplate["VARIABLE_DEPENDENCIES_POST"] = "{id}/dynamic/{dynamicId}/variable-dependencies";
    RequestTemplate["VARIABLE_DEPENDENCIES_PUT"] = "{id}/dynamic/{dynamicId}/variable-dependencies";
    RequestTemplate["VARIABLE_DEPENDENCIES_DELETE"] = "{id}/dynamic/{dynamicId}/variable-dependencies/{dependencyId}";
    RequestTemplate["VARIABLE_DEPENDENCIES_GRAPH_GET"] = "{id}/dynamic/{dynamicId}/variable-dependencies/graph";
    RequestTemplate["REFINED_CELL_MODEL_POST"] = "{id}/refinement";
    // Recipe
    RequestTemplate["RECIPE_POST"] = ".";
    RequestTemplate["RECIPE_PUT"] = "{id}";
    RequestTemplate["RECIPE_IMPORT"] = "import";
    RequestTemplate["RECIPE_PARSE_FOR_IMPORT"] = "parseforimport";
    RequestTemplate["ADD_LIQUID_STEP_PUT"] = "{id}/steps/{stepId}/addliquid";
    RequestTemplate["WAIT_STEP_PUT"] = "{id}/steps/{stepId}/wait";
    RequestTemplate["TIMESTAMP_STEP_PUT"] = "{id}/steps/{stepId}/timestamp";
    RequestTemplate["SET_TEMPERATURE_STEP_PUT"] = "{id}/steps/{stepId}/settemperature";
    RequestTemplate["SET_DO_STEP_PUT"] = "{id}/steps/{stepId}/setdo";
    RequestTemplate["SET_PH_STEP_PUT"] = "{id}/steps/{stepId}/setph";
    RequestTemplate["GAS_BIOREACTOR_STEP_PUT"] = "{id}/steps/{stepId}/gasbioreactor";
    RequestTemplate["STIR_BIOREACTOR_STEP_PUT"] = "{id}/steps/{stepId}/stirbioreactor";
    RequestTemplate["TAKE_SAMPLE_STEP_PUT"] = "{id}/steps/{stepId}/takesample";
    RequestTemplate["MEDIA_EXCHANGE_STEP_PUT"] = "{id}/steps/{stepId}/mediaexchange";
    RequestTemplate["BLEED_STEP_PUT"] = "{id}/steps/{stepId}/bleed";
    RequestTemplate["SET_DO_CONTROLLER_STEP_PUT"] = "{id}/steps/{stepId}/setdocontroller";
    RequestTemplate["SET_PH_CONTROLLER_STEP_PUT"] = "{id}/steps/{stepId}/setphcontroller";
    RequestTemplate["CONDITIONAL_STEP_FLOW_PUT"] = "{id}/condition-step/{conditionStepId}/flow/{flowId}";
    RequestTemplate["LOOP_STEP_CONDITION_PUT"] = "{id}/loopstep/{loopStepId}";
    RequestTemplate["ALTERNATIVE_STEP_POST"] = "{id}/alternative";
    RequestTemplate["ALTERNATIVE_STEP_PUT"] = "{id}/alternative";
    RequestTemplate["GAS_POST"] = "{id}/gases";
    RequestTemplate["GAS_PUT"] = "{id}/gases/{gasId}";
    RequestTemplate["GAS_DELETE"] = "{id}/gases/{gasId}";
    RequestTemplate["LIQUID_POST"] = "{id}/liquids";
    RequestTemplate["LIQUID_PUT"] = "{id}/liquids/{liquidId}";
    RequestTemplate["LIQUID_DELETE"] = "{id}/liquids/{liquidId}";
    RequestTemplate["PARAMETER_POST"] = "{id}/parameters";
    RequestTemplate["PARAMETER_PUT"] = "{id}/parameters/{parameterId}";
    RequestTemplate["PARAMETER_DELETE"] = "{id}/parameters/{parameterId}";
    RequestTemplate["CUSTOM_VARIABLE_POST"] = "{id}/custom-variables";
    RequestTemplate["CUSTOM_VARIABLE_PUT"] = "{id}/custom-variables/{variableId}";
    // RsWorkspace
    RequestTemplate["SCENARIO_CELL_MODEL_DELETE"] = "{id}/scenario/cell-models/{cellmodelId}";
    RequestTemplate["SCENARIO_RECIPE_DELETE"] = "{id}/scenario/recipes/{recipeId}";
    RequestTemplate["SCENARIO_SIMULATION_DELETE"] = "{id}/scenario/simulations/{simulationId}";
    RequestTemplate["SCENARIO_PROCESS_DATA_DELETE"] = "{id}/scenario/processdata/{processDataId}";
    RequestTemplate["RESULT_SET_PUT"] = "{id}/result-sets/{resultSetId}";
    RequestTemplate["RESULT_SET_ELEMENT_PUT"] = "{id}/result-sets/{resultSetId}/elements/{elementId}";
    RequestTemplate["RESULT_SET_ELEMENT_DUPLICATE"] = "{id}/result-sets/{resultSetId}/elements/{elementId}/duplicate";
    RequestTemplate["CELL_MODEL_CREATE_FROM_TABLE_RESULT_ELEMENT"] = "{id}/result-sets/{resultSetId}/elements/table/{elementId}/cell-model";
    RequestTemplate["RECIPE_CREATE_FROM_TABLE_RESULT_ELEMENT"] = "{id}/result-sets/{resultSetId}/elements/table/{elementId}/recipe";
    RequestTemplate["VARIANT_CREATE_FROM_TABLE_RESULT_ELEMENT"] = "{id}/result-sets/{resultSetId}/elements/table/{elementId}/adjustment";
    RequestTemplate["CELL_MODEL_CREATE_FROM_PROCESS_DATA_RESULT_ELEMENT"] = "{id}/result-sets/{resultSetId}/elements/{elementId}/result/process-data-viewer/cell-model";
    RequestTemplate["RECIPE_CREATE_FROM_PROCESS_DATA_RESULT_ELEMENT"] = "{id}/result-sets/{resultSetId}/elements/{elementId}/result/process-data-viewer/recipe";
    RequestTemplate["VARIANT_CREATE_FROM_PROCESS_DATA_RESULT_ELEMENT"] = "{id}/result-sets/{resultSetId}/elements/{elementId}/result/process-data-viewer/adjustment";
    RequestTemplate["CELL_MODEL_CREATE_FROM_SPACEVIEWER_RESULT_ELEMENT"] = "{id}/result-sets/{resultSetId}/elements/space-viewer/{elementId}/cell-model";
    RequestTemplate["RECIPE_CREATE_FROM_SPACEVIEWER_RESULT_ELEMENT"] = "{id}/result-sets/{resultSetId}/elements/space-viewer/{elementId}/recipe";
    RequestTemplate["VARIANT_CREATE_FROM_SPACEVIEWER_RESULT_ELEMENT"] = "{id}/result-sets/{resultSetId}/elements/space-viewer/{elementId}/adjustment";
    RequestTemplate["CELL_MODEL_CREATE_FROM_LINE_GRAPH_RESULT_ELEMENT"] = "{id}/result-sets/{resultSetId}/elements/line-graph/{elementId}/cell-model";
    RequestTemplate["RECIPE_CREATE_FROM_LINE_GRAPH_RESULT_ELEMENT"] = "{id}/result-sets/{resultSetId}/elements/line-graph/{elementId}/recipe";
    RequestTemplate["VARIANT_CREATE_FROM_LINE_GRAPH_RESULT_ELEMENT"] = "{id}/result-sets/{resultSetId}/elements/line-graph/{elementId}/adjustment";
    RequestTemplate["TABLE_ELEMENT_POST"] = "{id}/result-sets/{resultSetId}/elements/table";
    RequestTemplate["SPACEVIEWER_ELEMENT_POST"] = "{id}/result-sets/{resultSetId}/elements/space-viewer";
    RequestTemplate["PROCESS_DATA_VIEWER_ELEMENT_POST"] = "{id}/result-sets/{resultSetId}/elements/process-data-viewer";
    RequestTemplate["LINE_GRAPH_ELEMENT_POST"] = "{id}/result-sets/{resultSetId}/elements/line-graph";
    RequestTemplate["TABLE_ELEMENT_PUT"] = "{id}/result-sets/{resultSetId}/elements/table/{elementId}";
    RequestTemplate["SPACEVIEWER_ELEMENT_PUT"] = "{id}/result-sets/{resultSetId}/elements/space-viewer/{elementId}";
    RequestTemplate["PROCESS_DATA_VIEWER_ELEMENT_PUT"] = "{id}/result-sets/{resultSetId}/elements/process-data-viewer/{elementId}";
    RequestTemplate["LINE_GRAPH_ELEMENT_PUT"] = "{id}/result-sets/{resultSetId}/elements/line-graph/{elementId}";
    RequestTemplate["SPACEVIEWER_PARAMETER_PUT"] = "{id}/result-sets/{resultSetId}/elements/space-viewer/{elementId}/parameters/{parameterId}";
    RequestTemplate["SPACEVIEWER_SOURCE_PUT"] = "{id}/result-sets/{resultSetId}/elements/space-viewer/{elementId}/sources/{sourceId}";
    // Simulation
    RequestTemplate["SIMULATION_POST"] = "{id}/scenario/simulations";
    RequestTemplate["SIMULATION_PUT"] = "{id}/scenario/simulations/{simulationId}";
    // Variant
    RequestTemplate["VARIANT_POST"] = "{id}/scenario/simulations/{simulationId}/adjustments";
    RequestTemplate["VARIANT_PUT"] = "{id}/scenario/simulations/{simulationId}/adjustments/${adjustmentId}";
    RequestTemplate["VARIANT_DUPLICATE"] = "{id}/scenario/simulations/{simulationId}/adjustments/${adjustmentId}/duplicate";
    RequestTemplate["VARIANT_DELETE"] = "{id}/scenario/simulations/{simulationId}/adjustments/${adjustmentId}";
    // Insight
    RequestTemplate["INSIGHT_POST"] = "{id}/scenario/insights";
    RequestTemplate["INSIGHT_PUT"] = "{id}/scenario/insights/{insightId}";
    // Optimization
    RequestTemplate["OPTIMIZATION_POST"] = "{id}/scenario/optimizations";
    RequestTemplate["OPTIMIZATION_PUT"] = "{id}/scenario/optimizations/{optimizationId}";
    // Process Data
    RequestTemplate["PROCESS_DATA_POST"] = ".";
    RequestTemplate["CREATE_PROCESS_DATA_FROM_BATCH"] = "/import/{sessionId}";
    RequestTemplate["PROCESS_DATA_PUT"] = "{id}";
})(RequestTemplate || (RequestTemplate = {}));
export var MinMaxRestrictionsField;
(function (MinMaxRestrictionsField) {
    MinMaxRestrictionsField["MIN_VALUE"] = "MinValue";
    MinMaxRestrictionsField["MIN_VALUE_EQUAL"] = "MinValueEqual";
    MinMaxRestrictionsField["MAX_VALUE"] = "MaxValue";
    MinMaxRestrictionsField["MAX_VALUE_EQUAL"] = "MaxValueEqual";
})(MinMaxRestrictionsField || (MinMaxRestrictionsField = {}));
export var StatusRestrictionsField;
(function (StatusRestrictionsField) {
    StatusRestrictionsField["IS_MANDATORY"] = "IsMandatory";
    StatusRestrictionsField["DEFAULT"] = "Default";
})(StatusRestrictionsField || (StatusRestrictionsField = {}));
export var GetRestrictionsMethod;
(function (GetRestrictionsMethod) {
    GetRestrictionsMethod["POST"] = "Post";
    GetRestrictionsMethod["PUT"] = "Put";
    GetRestrictionsMethod["DELETE"] = "Delete";
})(GetRestrictionsMethod || (GetRestrictionsMethod = {}));
export var RemovableEntityType;
(function (RemovableEntityType) {
    RemovableEntityType["POPULATION"] = "Population";
    RemovableEntityType["DYNAMIC"] = "Dynamic";
    RemovableEntityType["POPULATION_EFFECT"] = "Effect";
    RemovableEntityType["VARIABLE_EFFECT"] = "Effect";
    RemovableEntityType["DEPENDENCY"] = "Dependency";
    RemovableEntityType["VARIABLE"] = "Environment Variable";
    RemovableEntityType["REFINE_PROCESS_DATA_OBJECT"] = "Process Data object";
    RemovableEntityType["CELL_MODEL"] = "Cell Model";
    RemovableEntityType["RECIPE"] = "Recipe";
    RemovableEntityType["SIMULATION"] = "Simulation";
    RemovableEntityType["SIMULATION_VARIANT"] = "variant of Simulation";
    RemovableEntityType["SIMULATION_VARIANT_PARAMETER"] = "parameter";
    RemovableEntityType["SIMULATION_VARIANT_FLOW"] = "flow";
    RemovableEntityType["PROCESS_DATA"] = "Process Data";
    RemovableEntityType["INSIGHT"] = "Insight";
    RemovableEntityType["OPTIMIZATION"] = "Optimization";
    RemovableEntityType["INSIGHT_INPUT_SET"] = "Input set";
    RemovableEntityType["INSIGHT_EVALUATION_OUTPUT"] = "Evaluation";
    RemovableEntityType["INSIGHT_COMPARISON_OUTPUT"] = "Comparison";
    RemovableEntityType["OPTIMIZATION_PARAMETER"] = "Parameter";
    RemovableEntityType["RECIPE_STEP"] = "Recipe Step";
    RemovableEntityType["RECIPE_PARAMETER"] = "Recipe Parameter";
    RemovableEntityType["RECIPE_GAS"] = "Recipe Gas";
    RemovableEntityType["RECIPE_LIQUID"] = "Recipe Liquid";
    RemovableEntityType["RECIPE_CONCURRENT_FLOW"] = "flow of Concurrent step";
    RemovableEntityType["RECIPE_CONDITIONAL_FLOW"] = "flow of Conditional step";
    RemovableEntityType["RECIPE_ALTERNATIVE_FLOW"] = "group of alternative flows";
    RemovableEntityType["RECIPE_ALTERNATIVE_STEP"] = "Alternative flows";
    RemovableEntityType["RECIPE_CUSTOM_VARIABLE"] = "Custom Variable";
    RemovableEntityType["CALCULATION_QUEUE"] = "Result elements";
    RemovableEntityType["CALCULATION_QUEUE_ELEMENT"] = "Result element";
    RemovableEntityType["CALCULATION_QUEUE_ROW"] = "Source";
    RemovableEntityType["RESULT_SET"] = "Result Set";
    RemovableEntityType["RESULT_SET_ELEMENT"] = "Result element";
})(RemovableEntityType || (RemovableEntityType = {}));
export var HighlightEntityType;
(function (HighlightEntityType) {
    HighlightEntityType["CELL_MODEL"] = "Cell Model";
    HighlightEntityType["RECIPE"] = "Recipe";
    HighlightEntityType["SIMULATION"] = "Simulation";
    HighlightEntityType["PROCESS_DATA"] = "Process Data";
    HighlightEntityType["INSIGHT"] = "Insight";
    HighlightEntityType["OPTIMIZATION"] = "Optimization";
})(HighlightEntityType || (HighlightEntityType = {}));
